module.exports = __webpack_public_path__ + "img/gimont-city.b787315e.png";